<template>
	<div class="page">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="/order/add">
				<el-button type="success" round>
					<span class="el-icon-plus"></span>
					提交订单
				</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<el-card class="padding" :body-style="{ padding: '0px' }">
				<el-form :inline="true" :model="formSearch" class="demo-form-inline">
					<el-form-item label="订单状态">
						<el-select v-model="formSearch.data.state" clearable placeholder="订单状态" style="width: 120px;">
							<el-option v-for="item in infos_state" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="下单方式">
						<el-select v-model="formSearch.data.source" clearable placeholder="订单状态" style="width: 120px;">
							<el-option label="微信小程序" value="wxapp"></el-option>
							<el-option label="PC端网站" value="webpc"></el-option>
							<el-option label="移动端网站" value="webmobile"></el-option>
							<el-option label="其他" value="other"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="提交时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="getInfoList">查询</el-button></el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card margin-top" :body-style="{ padding: '0px' }">
				<el-table
					:data="tableData"
					border
					style="width: 100%; min-height: 400px;"
					v-loading="loading"
					element-loading-text="加载中..."
					element-loading-spinner="el-icon-loading"
				>
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
					<el-table-column prop="orderid" align="center" label="订单编号" width="150"></el-table-column>
					<el-table-column prop="customer" align="center" label="客户名称">
						<template slot-scope="scope">
							<span class="text-blue text-bold">{{ scope.row.customer.name }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单状态" width="80">
						<template slot-scope="scope">
							<el-tag type="primary" size="small" effect="dark" v-if="scope.row.stateflag == 1">入账</el-tag>
							<el-tag type="warning" size="small" effect="dark" v-else-if="scope.row.stateflag == 2">出账</el-tag>
							<span class="cu-tag bg-red round" v-else-if="scope.row.stateflag == 0">待处理</span>
							<el-tag type="info" size="small" v-else>未知</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="money" align="right" label="订单金额" width="110">
						<template slot-scope="scope">
							<span class="text-blue text-bold" v-format="'￥,##0.00'">{{ scope.row.money / 100 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" align="center" label="提交时间" width="160"></el-table-column>
					<el-table-column prop="dealtime" align="center" label="处理时间" width="160"></el-table-column>
					<el-table-column prop="finishtime" align="center" label="处理完成时间" width="180"></el-table-column>
					<el-table-column prop="source" align="center" label="下单方式" width="100">
						<template slot-scope="scope">
							<span class="text-green" v-if="scope.row.source == 'wxapp'">微信小程序</span>
							<span class="text-blue" v-else-if="scope.row.source == 'webpc'">PC端网站</span>
							<span class="text-mauve" v-else-if="scope.row.source == 'webmobile'">移动端网站</span>
							<span class="text-brown" v-else>其他</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<router-link :to="'/order/view/' + scope.row.orderid"><el-button size="small" type="primary">查看</el-button></router-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="padding-tb text-right">
					<el-pagination
						background
						@size-change="pageSizeChange"
						@current-change="pageChange"
						:current-page="formSearch.page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="20"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loadingPage: false,
			infos_agent: [],
			infos_state: [],
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			total: 0,
			loading: false,
			tableData: []
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadingPage = true;
		this.$http.post('/server/index.php?m=order/list&a=init', this.formSearch).then(
			res => {
				this.loadingPage = false;
				if (res.result == 'ok') {
					this.infos_agent = res.data.infos_agent;
					this.infos_state = res.data.infos_state;
					this.getInfoList();
				} else {
					this.$alert(res.msg, {
						title: '操作错误',
						type: 'error'
					});
				}
			},
			r => {
				this.loadingPage = false;
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getInfoList() {
			this.loading = true;
			this.$http.post('/server/index.php?m=order/list&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData = res.data.infos;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				err => {
					this.loading = false;
					console.log(err);
					if (err) {
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getInfoList();
		}
	}
};
</script>

<style>
.demo-form-inline .el-form-item {
	margin-bottom: 0;
}
</style>
